import "./styles.scss";

import { useTranslation } from "react-i18next";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "back-mobile";

const BackMobile = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button className={mainClass} type="button" onClick={onClick}>
      <i>
        <ArrowIcon />
      </i>
      <span>{t("Back")}</span>
    </button>
  );
};

export default BackMobile;
